import React, { useState, useEffect, useContext } from 'react';
import { BASE_URL, instanceAxios } from "../../config";
import { toast } from "react-toastify";

export default function Login(props) {
    const [Email, SetEmail] = useState('');
    const [Password, SetPassword] = useState('');     
    const logininSite = () => {
        let config = {
            mode: 'cors',
            method: 'post',
            url: `${BASE_URL}/UserInfo.ashx`,
            headers: {
                Accept: "application/json",
            },
            data: JSON.stringify({
                Method: 'login',
                Email: Email,
                Password: Password               
            })
        };
        instanceAxios(config)
            .then(function (response) {
                if (response.status === 200) {
                    if (response.data !== undefined && response.data.length != 0) {
                        InfoData(response.data);

                    }
                    else {
                        toast.info("ورود ناموفق", {
                            closeButton: true,
                            autoClose: 1500
                        });

                    }
                }
            })
            .catch((err) => {
                toast.warning(err.response ? 'بروز خطا' + err ?.response ?.data ?.msg : 'بروز خطا' + err.message, {
                    closeButton: false,
                    autoClose: 1500
                });
            })
    }

    const InfoData = (data) => {       
        props.UserloginId(data[0].Id);
        localStorage.setItem("accessToken", data[0].jwt_id);       
    }  
    
    return (
        
        <div style={{ marginTop: "200px",width:"300px"}}>
            <div className="form-group has-feedback">
                <input type="email" className="form-control" value={Email} onChange={(e) => SetEmail(e.target.value)} placeholder=" تلفن/ایمیل" style={{ fontSize: "14px", direction: "rtl" }} />
                <i className="icon ion-ios-email-outline form-control-feedback" style={{ fontSize: "30px" }}></i>
            </div>
            <div className="form-group has-feedback">
                <input type="password" className="form-control" value={Password} onChange={(e) => SetPassword(e.target.value)} placeholder="رمز عبور" style={{ fontSize: "14px" }} />
                <i className="icon ion-ios-locked-outline form-control-feedback" style={{ fontSize: "30px" }}></i>
            </div>

            <div className="row">
                <div className="col-xs-12 " style={{display:"none"}}>
                    <div className="checkbox icheck" style={{ marginTop: "1px" }}>
                        <label className="pull-right" style={{ marginRight: "20px", fontSize: "13px" }}>
                            <input type="checkbox" /> مرا به خاطر بسپار
                                        </label>
                    </div>
                </div>
                <div className="col-xs-12" style={{ marginTop: "10px" }}>
                    <button className="btn btn-primary btn-block btn-flat" style={{ fontSize: "14px" }} onClick={(e) => logininSite()}>ورود</button>
                </div>
            </div>
        </div>

    );
} 
